import type { StyleFunction } from "@venuepos/react-common";

export const dashboardStyleFunc: StyleFunction = theme => ({
    row: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    topRow: {
        height: 100,
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        padding: theme.spacingScale,
        backgroundColor: theme.colors.grey100,
        borderRadius: theme.borderRadiusSmall,
        columnGap: theme.spacingScale,
    },
    totalRow: {
        flexDirection: "row",
    },
    totalValue: {
        fontSize: Object(theme.headlines.h4).fontSize,
    },
    dateLabel: {
        marginRight: theme.spacingScale,
    },
    widget: {
        flex: 1,
        elevation: 1,
        margin: theme.spacingScale,
    },
    widgetContentHolder: {
        ...theme.styles.flex1,
    },
    calendarArrow: {
        marginTop: 24,
    },
    noteText: {
        marginTop: theme.spacingScale,
        fontSize: 14,
    },
    darkRow: {
        backgroundColor: theme.colors.grey50,
    },

    totalHeadline: {
        //
    },
    compareHeadline: {
        color: theme.colors.grey500,
    },
    compareValue: {
        fontSize: Object(theme.headlines.h5).fontSize,
        color: theme.colors.grey500,
    },

    tableHeaders: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    linkText: {
        ...theme.styles.link,
    },

    widerColumn: {
        flex: 2,
    },
    widgetContent: { width: "100%", height: "100%" },

    defaultBar: {
        height: 7,
        backgroundColor: theme.colors.grey500,
        marginVertical: 2,

        borderTopRightRadius: 2,
        borderBottomRightRadius: 2,
    },
    positiveBar: {
        backgroundColor: theme.colors.success,
    },
    negativeBar: {
        backgroundColor: theme.colors.error,
    },

    graphHolder: {
        paddingVertical: theme.spacingScale / 2,
        backgroundColor: theme.colors.grey50,
        borderColor: theme.colors.grey100,
        borderWidth: 1,
        borderStyle: "solid",
        marginVertical: theme.spacingScale / 2,
    },
    graphHolderEmpty: {
        borderColor: `${theme.colors.info}80`,
        backgroundColor: theme.colors.grey100,
    },

    dataRow: {
        ...theme.styles.row,
        marginBottom: 2,
        justifyContent: "space-between",
    },

    dataSingleValue: {
        flex: 1,
        alignItems: "center",
    },
    widgetContainer: {
        minHeight: 300,
        alignContent: "center",
        justifyContent: "center",
    },
    noDataText: {
        ...theme.styles.smallText,
        color: theme.colors.textDark,

        // Make the size of the "no data" text fit the size of the graph
        marginHorizontal: theme.spacingScale / 2,
        lineHeight: 12,
    },
});
